import { useEffect, useRef, useState } from "react";

export default function StorySection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Image */}
          <div
            className={`relative transition-all duration-700 ${
              visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"
            }`}
          >
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://storage.helloreaddy.io/project_files/d9750558-9174-4b87-9b66-b2ab1bef0e5e/1532c902-6fd9-4a0d-879c-9f4135677993_compressed_FB_IMG_1787391191368.webp"
                alt="Không gian chăm sóc tại Xanh Wellness"
                className="w-full h-72 md:h-[480px] object-cover object-center"
              />
              <div className="absolute bottom-4 left-4 bg-background-50/95 backdrop-blur-sm rounded-lg p-3 md:p-4 border border-background-200/70">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-heart-3-line text-lg md:text-xl" />
                  </div>
                  <div>
                    <div className="font-display text-base md:text-lg font-bold text-foreground-950">
                      Tận tâm
                    </div>
                    <div className="text-xs text-foreground-600 font-label">
                      Trong từng liệu trình
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="absolute -z-10 -bottom-4 -right-4 w-32 h-32 md:w-48 md:h-48 bg-accent-100/50 rounded-lg" />
          </div>

          {/* Content */}
          <div
            className={`transition-all duration-700 delay-200 ${
              visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"
            }`}
          >
            <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-primary-100 text-primary-700 text-xs md:text-sm font-label font-medium rounded-full mb-4">
              <i className="ri-sparkling-2-line" />
              Câu chuyện của chúng tôi
            </span>
            <h2 className="font-display text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              Khởi nguồn từ khát khao{" "}
              <span className="text-primary-600">chăm sóc đúng nghĩa</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-5 leading-relaxed font-body">
              Giữa nhịp sống hối hả, chúng tôi nhận ra rằng ai cũng cần một nơi để lắng lại, để cơ thể được nghỉ ngơi và phục hồi. Vì thế, Xanh Wellness được thành lập với sứ mệnh mang đến giải pháp chăm sóc sức khỏe hiện đại, an toàn và hiệu quả cho tất cả mọi người.
            </p>
            <p className="text-sm md:text-base text-foreground-600 mb-5 leading-relaxed font-body">
              Chúng tôi ứng dụng công nghệ cabin spa thông minh — giúp giảm cân, giảm mỡ, cải thiện vóc dáng và thư giãn cơ thể chỉ trong 40 phút. Không cần phẫu thuật, không xâm lấn, không cần tập luyện gắt gao.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed font-body">
              Mỗi liệu trình đều được thiết kế tận tâm bởi đội ngũ chuyên viên giàu kinh nghiệm, để bạn ra về với một cơ thể khỏe khoắn và một tinh thần thư thái.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}